export default __webpack_public_path__ + "static/media/img-slider-asaph-7.2371ad44.png";